import client from "./client";

export default {

    async getUserTypes(filters) {
        return client.parseResponse(await client.get('/user-types', filters));
    },
    async getUserType(id) {
        return client.parseResponse(await client.get('/user-types/' + id));
    },
    async createUserType(data) {
        return client.parseResponse(await client.post('/user-types', data))
    },
    async editUserType(data) {
        return client.parseResponse(await client.put('/user-types/' + data.id, data))
    },
    async deleteUserType(data) {
        return client.parseResponse(await client.delete('/user-types/' + data.id, data))
    }
}
